import * as types from './mutation-types'
import axios from 'axios'
import { obterDadosEmpresariais, obterDadosPessoais, obterFormulario } from './state'

const tratarRotaApi = (url) => window._Vue.$contextManager.handleApiPrefix(url)

export const ActionResetarDadosFormularioEscritorio = ({ commit }) => {
  commit(types.SET_DADOS_FORMULARIO_ESCRITORIO, obterFormulario())
}
export const ActionResetarDadosPessoaisFormularioEscritorio = ({ commit }) => {
  commit(types.SET_DADOS_FORMULARIO_INFORMACOES_PESSOAIS, obterDadosPessoais())
}
export const ActionResetarDadosEmpresariaisFormularioEscritorio = ({ commit }) => {
  commit(types.SET_DADOS_FORMULARIO_INFORMACOES_EMPRESARIAIS, obterDadosEmpresariais())
}
export const ActionPopularDadosFormulario = ({ commit }, formulario) => {
  commit(types.SET_DADOS_FORMULARIO_INFORMACOES, formulario)
  commit(types.SET_DADOS_FORMULARIO_ENDERECO, formulario)
  commit(types.SET_DADOS_FORMULARIO_CONTATO, formulario)
  commit(types.SET_DADOS_FORMULARIO_INFORMACOES_PESSOAIS, formulario)
  commit(types.SET_DADOS_FORMULARIO_INFORMACOES_EMPRESARIAIS, formulario)
  // feature flag da Gestão de Produtos: vem no payload do escritório (ObterEmpresaUseCase)
  commit(types.SET_GESTAO_PRODUTOS_HABILITADO,
    formulario.gestaoProdutosHabilitado === true || formulario.gestaoProdutosHabilitado === 'true')
}
export const ActionResetarDadosRetornoCadastro = ({ commit }) => {
  commit(types.SET_DADOS_RETORNO_CADASTRO, {
    sucesso: false,
    mensagem: '',
    listaDeErros: {}
  })
}

export const ActionDefinirListaUsuariosRepresentateLegal = async ({ commit }, parametrosRequisicao) => {
  const url = tratarRotaApi('/representantes-legais')
  const resposta = await axios.post(url, parametrosRequisicao)
  commit(types.SET_LISTA_USUARIOS_REPRESENTANTE_LEGAL, resposta.data.retorno.dados)
}

export const ActionDefinirListaUnidadesFederativas = async ({ commit }, parametrosRequisicao) => {
  const url = tratarRotaApi('/escritorios/unidades-federativas')
  const resposta = await axios.post(url, parametrosRequisicao)
  commit(types.SET_LISTA_UNIDADES_FEDERATIVAS, resposta.data.retorno.dados)
}

export const ActionObterEscritorio = async ({ dispatch }, id) => {
  const url = tratarRotaApi('/escritorios/escritorio/' + id)
  const resposta = await axios.get(url)
  dispatch('ActionPopularDadosFormulario', resposta.data.retorno.dados)
}

export const ActionSalvarEscritorio = async ({ commit }, formData) => {
  const url = tratarRotaApi('/escritorios/salvar')
  const resposta = await axios.post(url, formData)

  commit(types.SET_DADOS_RETORNO_CADASTRO, {
    sucesso: resposta.data.retorno.sucesso,
    mensagem: resposta.data.retorno.mensagem,
    listaDeErros: resposta.data.retorno.listaDeErros
  })
}
